import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type {
  NotificationTemplateApiResponse,
  NotificationTemplateUpdatePayload,
} from "interface/notificationTemplate";

export const notificationTemplateApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotificationTemplates: builder.query<
      NotificationTemplateApiResponse,
      { [key: string]: string | number }
    >({
      query: (params) => ({
        url: API.GET_NOTIFICATION_TEMPLATE,
        method: "GET",
        params,
      }),
      providesTags: ["NotificationTemplate"],
    }),
    updateNotificationTemplate: builder.mutation<
      NotificationTemplateApiResponse,
      NotificationTemplateUpdatePayload
    >({
      query: ({ params }) => ({
        url: API.GET_NOTIFICATION_TEMPLATE,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["NotificationTemplate"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update notification template:", error);
        }
      },
    }),
  }),
});

export const {
  useGetNotificationTemplatesQuery,
  useUpdateNotificationTemplateMutation,
} = notificationTemplateApi;
